import { Box, Tabs, Tab } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import SellIcon from "@mui/icons-material/Sell";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import ShelvesIcon from '@mui/icons-material/Shelves';
import AnalyticsIcon from '@mui/icons-material/Analytics';

import theme from "../../configs/theme";
import Logo from "../components/Logo";
import DigitalClock from "../components/Clock";

const iconMap = {
  home: <HomeIcon />,
  sell: <SellIcon />,
  chart: <ShowChartIcon />,
  warehouse: <WarehouseIcon />,
  shelves: <ShelvesIcon />,
  analytics: <AnalyticsIcon />,
};

export default function NavbarUI({ selected, handleChange, tabs }) {
  return (
    <Box
      sx={{
        width: "16%",
        height: "100vh",
        backgroundColor: "#0f0f0f",
        color: theme.textColors.white,
        display: "flex",
        flexDirection: "column",
        position: "fixed",
      }}
    >
      {/* Logo */}
      <Box
        sx={{
          width: "100%",
          height: "11.8%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderBottom: "1px solid #333",
        }}
      >
        <Logo />
      </Box>

      {/* Lista de navegación */}
      <Tabs
        orientation="vertical"
        value={selected}
        onChange={handleChange}
        sx={{
          flexGrow: 1,
          "& .MuiTab-root": {
            // Aplica estilos a todos los Tab
            color: theme.textColors.white,
            textTransform: "none",
            fontSize: { sm: theme.fontSizes.small, md: theme.fontSizes.medium },
            padding: { sm: "16px", md: "18px" },
            transition: "background 0.3s",
            flexDirection: "row",
            justifyContent: "flex-start",
            gap: 2,
            alignItems: "center",

            "&:hover": {
              backgroundColor: theme.colors.terciary,
            },

            "& .MuiTab-iconWrapper": {
              marginBottom: "0 !important",
              fontSize: "24px",
              transition: "font-size 0.3s",
            },
          },
          "& .Mui-selected": {
            color: "#ffffff !important",
            fontWeight: "bold",
            "& .MuiTab-iconWrapper": {
              fontSize: "30px", // Agranda el icono en el tab seleccionado
            },
          },
          "& .MuiTabs-indicator": {
            width: { sm: "6px", md: "10px" },
            backgroundColor: theme.colors.white,
          },
        }}
      >
        {tabs.map(tab => (
          <Tab
            key={tab.value}
            icon={iconMap[tab.icon]}
            label={tab.label}
            value={tab.value}
          />
        ))}
      </Tabs>

      <Box
        sx={{
          width: "100%",
          height: "10%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderTop: "1px solid #333",
        }}
      >
        <DigitalClock />
      </Box>
    </Box>
  );
}
